import { FaShare } from "react-icons/fa";

const ShareIcon = () => {
  return (
    <FaShare className="h-7 w-7 text-gray-500 hover:text-red-600 dark:hover:text-green-800  cursor-pointer" />
  );
};

export default ShareIcon;

// const ShareIcon = () => {
//   return (
//     <FaShare className="h-7 w-7 text-gray-500 hover:text-black cursor-pointer" />
//   );
// };
